import { ParameterInfos } from 'ut-business/parameter';

const COMMON_INSPECTION_MODE = {
  inspectionMode: {
    setup: {
      isReadOnly: false,
    },
    inspection: {
      isReadOnly: false,
    },
    pause: {
      isReadOnly: false,
    },
    analysis: {
      isReadOnly: false,
    },
  },
};

const METRIC_CONFIG = {
  unit: 'mm' as const,
  decimals: 2,
  defaultStep: 1,
  limit: {
    min: 0,
  },
  steps: [
    0.01,
    0.1,
    1,
    10,
  ],
};

const IMPERIAL_CONFIG = {
  unit: 'in' as const,
  decimals: 3,
  defaultStep: 0.05,
  limit: {
    min: 0,
  },
  steps: [
    0.005,
    0.05,
    0.5,
    5,
  ],
};

export const thicknessParameters: Record<string, ParameterInfos> = {
  DisplayCscanThicknessFirstGate: COMMON_INSPECTION_MODE,
  DisplayCscanThicknessSecondGate: COMMON_INSPECTION_MODE,
  DisplayCscanThicknessMinimum: {
    sourceUnit: 'm',
    metric: METRIC_CONFIG,
    imperial: IMPERIAL_CONFIG,
    ...COMMON_INSPECTION_MODE,
  },
  DisplayCscanThicknessMaximum: {
    sourceUnit: 'm',
    metric: METRIC_CONFIG,
    imperial: IMPERIAL_CONFIG,
    ...COMMON_INSPECTION_MODE,
  },
};
